import applePayMark from "../.././assets/payment/applepay/mark.png";
import payLaterMark from "../.././assets/payment/paylater/mark.png";
import paypalMark from "../.././assets/payment/paypal/mark.png";
import venmoMark from "../.././assets/payment/venmo/mark.png";

/**
 * This is the card processer value to expect from the rox-app
 * "paypal"
 */

/**
 * PayPal valid funding sources to render the button
 * ["card", "paypal", "paylater", "applepay", "venmo"]
 * We disable "card" to prevent PayPal card payment from being an option
 */
export const CARD = "card";
export const PAYPAL = "paypal";
export const PAYLATER = "paylater";
export const APPLEPAY = "applepay";
export const VENMO = "venmo";

export const REFUND =
  "Refund will be applied to your original payment method within 7 days";

export const FUNDING_ELIGIBILITY_ERROR =
  "You are not eligible to checkout with {paymentMethod}. Please select a different payment method.";
export const PREVIOUS_PAYEMENT_METHOD_NOT_AVAILABLE =
  "Your original payment method is no longer available.";

const paymentMethods = [
  {
    fundingSource: CARD,
    processor: PAYPAL,
    label: "Debit/Credit Card",
    mark: null,
    minimumAmt: 0,
    message: "Enter your debit or credit card information:",
    isInstallment: false,
  },
  {
    fundingSource: APPLEPAY,
    processor: PAYPAL,
    label: "Apple Pay",
    mark: applePayMark,
    minimumAmt: 1.0,
    message:
      "We’ll guide you to Apple Pay’s secure checkout to pay and complete your order.",
    isInstallment: false,
  },
  {
    fundingSource: PAYPAL,
    processor: PAYPAL,
    label: "PayPal",
    mark: paypalMark,
    minimumAmt: 0.0,
    message:
      "We’ll guide you to PayPal’s secure window to pay and complete your order.",
    isInstallment: false,
  },
  {
    fundingSource: PAYLATER,
    processor: PAYPAL,
    label: "PayPal Pay Later",
    mark: payLaterMark,
    minimumAmt: 30.0,
    message:
      "We’ll guide you to PayPal’s secure window to pay and complete your order.",
    isInstallment: true,
  },
  {
    fundingSource: VENMO,
    processor: PAYPAL,
    label: "Venmo",
    mark: venmoMark,
    minimumAmt: 1.0,
    message:
      "We’ll display the QR code to scan in your Venmo app to pay and complete your order.",
    isInstallment: false,
  },
];

export default paymentMethods;

export const getPaymentMethodByKey = (key, value) => {
  return paymentMethods.find((x) => x[key] === value);
};
